export default __webpack_public_path__ + "static/media/x.ffa2ebc5.png";